__turbopack_context__.v({
  "btn__close": "MembershipSuccessPopup-module-scss-module__VuEo4G__btn__close",
  "fade-in": "MembershipSuccessPopup-module-scss-module__VuEo4G__fade-in",
  "membership_success_popup": "MembershipSuccessPopup-module-scss-module__VuEo4G__membership_success_popup",
  "passport_compass": "MembershipSuccessPopup-module-scss-module__VuEo4G__passport_compass",
  "vanish": "MembershipSuccessPopup-module-scss-module__VuEo4G__vanish",
});
